"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fetch;
exports.defaultOptions = void 0;

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var defaultOptions = {
  method: 'GET',
  headers: {},
  credentials: 'same-origin'
};
exports.defaultOptions = defaultOptions;

function fetch(location) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return new _promisePolyfill.default(function (resolve) {
    options = Object.assign({}, defaultOptions, options);

    if (global.fetch) {
      resolve(global.fetch(location, options));
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open(options.method, location, true);
    Object.keys(options.headers).forEach(function (header) {
      return xhr.setRequestHeader(header, options.headers[header]);
    });

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4) {
        resolve(Response.createFromXHR(location, xhr));
      }
    };

    xhr.onerror = function (event) {
      var err = new TypeError("Error in XMLHttpRequest");
      reject(err);
    };

    xhr.send(options.body);
  });
}

var ArrayIterator =
/*#__PURE__*/
function () {
  function ArrayIterator(values) {
    babelHelpers.classCallCheck(this, ArrayIterator);
    this._position = 0;
    this._values = values;
  }

  babelHelpers.createClass(ArrayIterator, [{
    key: "next",
    value: function next() {
      if (this._position >= this._values.length) {
        return {
          done: true
        };
      }

      return {
        done: false,
        value: this._values[this._position++]
      };
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this;
    }
  }]);
  return ArrayIterator;
}();

var Headers = global.Headers ||
/*#__PURE__*/
function () {
  function Headers() {
    babelHelpers.classCallCheck(this, Headers);
    this._map = {};
  }

  babelHelpers.createClass(Headers, [{
    key: "append",
    value: function append(name, value) {
      if (this._map[name]) this._map[name] += '; ' + value;else this._map[name] = value;
    }
  }, {
    key: "delete",
    value: function _delete(name) {
      delete this._map[name];
    }
  }, {
    key: Symbol.iterator,
    value: function value() {
      return this.entries();
    }
  }, {
    key: "entries",
    value: function entries() {
      var _this = this;

      return new ArrayIterator(Object.keys(this._map).map(function (key) {
        return [key, _this._map[key]];
      }));
    }
  }, {
    key: "get",
    value: function get(name) {
      return this._map[name];
    }
  }, {
    key: "has",
    value: function has(name) {
      return name in this._map;
    }
  }, {
    key: "keys",
    value: function keys() {
      return new ArrayIterator(Object.keys(this._map));
    }
  }, {
    key: "set",
    value: function set(name, value) {
      this._map[name] = value;
    }
  }, {
    key: "values",
    value: function values() {
      var _this2 = this;

      return new ArrayIterator(Object.keys(this._map).map(function (v) {
        return _this2._map[v];
      }));
    }
  }]);
  return Headers;
}();

var Response = global.Response ||
/*#__PURE__*/
function () {
  function Response() {
    babelHelpers.classCallCheck(this, Response);
    this.headers = new Headers();
    this.ok = true;
    this.redirected = false;
    this.status = 200;
    this.statusText = "";
    this.type = "basic";
    this.url = "";
    this.useFinalURL = true;
  }

  babelHelpers.createClass(Response, [{
    key: "clone",
    value: function clone() {
      var r = new Response();
      var it = this.headers.entries(),
          v;

      while (v = it.next()) {
        if (v.done) break;
        r.headers.set(v.value[0], v.value[1]);
      }

      r.ok = this.ok;
      r.redirected = this.redirected;
      r.status = this.status;
      r.statusText = this.statusText;
      r.type = this.type;
      r.url = this.url;
      r.useFinalURL = this.useFinalURL;
      return r;
    }
  }, {
    key: "json",
    value: function json() {
      return _promisePolyfill.default.resolve(JSON.parse(this._textContent));
    }
  }, {
    key: "text",
    value: function text() {
      return _promisePolyfill.default.resolve(this._textContent);
    }
  }, {
    key: "blob",
    value: function blob() {
      return _promisePolyfill.default.resolve(new Blob([this._textContent], {
        type: this.headers.get('content-type')
      }));
    }
  }], [{
    key: "createFromXHR",
    value: function createFromXHR(url, xhr) {
      var r = new Response();
      xhr.getAllResponseHeaders().split("\r\n").forEach(function (headerLine) {
        var t = /([^:]+):\s*(.*)$/.exec(headerLine);
        if (t) r.headers.set(t[1].toLowerCase(), t[2]);
      });
      r.ok = xhr.status >= 200 && xhr.status <= 299;
      r.status = xhr.status;
      r.url = url;
      r._textContent = xhr.responseText;
      return r;
    }
  }]);
  return Response;
}();